module.exports = __webpack_public_path__ + "img/delete-remove-fill-svgrepo-com.dc77b482.svg";